import React from 'react';
import Helmet from 'react-helmet';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import TestimonialsCareers from '../../components/TestimonialsCareers.js';


const Home = (props) => {
	const location = props.location;

	return (
		<Layout  bodyClass="page-home-index2" ontouchstart>
			<SEO title="Careers | ChartHop | People Analytics, Visualized" />
			<Helmet>
				<meta name="description" content="We are on a mission to build transparent and human-centered workforces. Come join us." />
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="Careers | ChartHop | People Analytics, Visualized" />
				<meta property="og:description" content="We are on a mission to build transparent and human-centered workforces. Come join us." />
				<meta property="og:image" content={`https://www.charthop.com/home/about-meta.png`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
				<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="Careers | ChartHop | People Analytics, Visualized" />
				<meta name="twitter:description" content="We are on a mission to build transparent and human-centered workforces. Come join us." />
				<meta name="twitter:image" content={`https://www.charthop.com/home/about-meta.png`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
				<meta name="twitter:creator" content="@charthop" />
			</Helmet>
			<section className="intro container">
				<div className="row align-items-center justify-content-center">
					<div className="text-container">
						<div className="intro-title">
							<h1>
								We are on a mission <br className="br-hide" />to build <blueText>transparent</blueText> and <br className="br-hide" /><blueText>human-centered</blueText> workforces.
							</h1>
							<p>
								That means ensuring our company is transparent, inclusive, and supportive. And that we hire the best humans to build it, together.
							</p>
						</div>
					</div>
					<img src="/company/careers/team-desktop.png" alt="Charthop Team" className="desktop" />
					<img src="/company/careers/team-1024.png" alt="Charthop Team" className="tablet" />
					<a href="/company/job-openings/" className="button primary join-team" target="_blank">
						JOIN OUR TEAM
					</a>
				</div>
			</section>

			<TestimonialsCareers bgGrey />

			{/*Ceo message*/}
			<section className="ceo container">
				<div className="ceo-title">
					<h2 className="desktop">Message from our CEO, Ian White</h2>
					<h2 className="tablet">Message from our CEO, <br />Ian White</h2>
				</div>
				<div className="ceo-information">
					<div className="ceo-information-image">
						<img src="/company/careers/CEO-image-2.png" alt="Ian White with his family" />

					</div>
					<div className="ceo-information-text">
						<p>
							A great company is about more than just building an amazing product. It’s about building value for everyone: customers, employees, shareholders and partners.<br />
						</p>
						<p>
							And a great company culture certainly isn't defined by ping-pong tables and happy hours.<br />
						</p>
						<p>
							Great companies are, above all, about great teams and great people -- working together, overcoming obstacles together, and winning together.<br />
						</p>
						<p>
							More than anything else we've accomplished so far, I'm most proud of the amazing team that we've assembled.<br />
						</p>
						<p>
							It's a team that believes the future of organizations should be transparent, inclusive, and connected. And it's a team that is building the next evolution of software, and redefining the organization, to achieve that future together.<br />
						</p>
						<p>
							Come join us.
						</p>
						<div className="ceo-sign">
							<img src="/company/careers/CEO-signature.png" alt="Signature from Ian White" />
						</div>
					</div>
				</div>
			</section>

			{/* ORGANIZATIONS */}
			<section className="our-values bgGrey">
				<div className="container">
					<div className="our-values-title">
						<h2 className="text-center">Our values</h2>
					</div>
					<div className="svg-info">
						<div className="svg-info-card-4col">
							<img src={'/company/icons/company-values_fast.svg'} alt="Fast" />
							<p className="svg-info-card-4col-subtitle">Move with intentional speed.</p>
						</div>
						<div className="svg-info-card-4col">
							<img src={'/company/icons/company-values_inclusive.svg'} alt="Inclusive" />
							<p className="svg-info-card-4col-subtitle">Welcome our differences.</p>
						</div>
						<div className="svg-info-card-4col">
							<img src={'/company/icons/company-values_transparent.svg'} alt="Transparent" />
							<p className="svg-info-card-4col-subtitle">Trust, collaborate, share.</p>
						</div>
						<div className="svg-info-card-4col">
							<img src={'/company/icons/company-values_optimistic.svg'} alt="Optimistic" />
							<p className="svg-info-card-4col-subtitle">Dream big, think practically.</p>
						</div>
					</div>

					{/* 					<div className="svg-info spacing-up">
						<div className="svg-info-card-3col">
							<img src={'/company/icons/humanity_icon.svg'} alt="Humanity" title="Humanity" />
							<p className="svg-info-card-3col-title">Lead with empathy</p>
							<p className="svg-info-card-3col-subtitle">We support each other, our customers and our community.</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/company/icons/protect_icon.svg'} alt="Protect" title="Protect" />
							<p className="svg-info-card-3col-title">Secure above all</p>
							<p className="svg-info-card-3col-subtitle">We protect our customers' data like our lives depend on it.</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/company/icons/truth_icon.svg'} alt="Truth" title="Truth" />
							<p className="svg-info-card-3col-title">Move intentionally</p>
							<p className="svg-info-card-3col-subtitle">We move fast and we try not to break things.</p>
						</div>
					</div> */}
				</div>
			</section>

			{/*Vp message*/}
			<section className="vp">
				<div className="vp-information container">
					<div className="vp-text">
						<p>
							“I believe in the power of tools and tech to disrupt and revolutionize stodgy old domains. At ChartHop we’re solving real problems for real people.”
						</p>
						<a href="/blog/company-updates/engineering-leader-julie-sommerville/" className="ctaStandard smallMobile">Read our full interview with Julie</a>
					</div>
					<div className="vp-image">
						<img src="/company/quotes/Quote-image.png" alt="" />
					</div>
				</div>
			</section>

			{/*Benefits*/}
			<section className="bgGrey benefits desktop">
				<div className="container desktop">
					<div className="benefits-title">
						<h2 className="text-center">Benefits</h2>
					</div>
					<div className="pgc1 max-width-pgc1 display-block-pgc1 text-left">
						<div className="pgc2">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Healthcare benefits</p>
							</div>
						</div>
						<div className="pgc2">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>401k</p>
							</div>
						</div>
						<div className="pgc2">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Paid time off</p>
							</div>
						</div>
						<div className="pgc2">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Mental health benefits</p>
							</div>
						</div>
						<div className="pgc2">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Professional development stipend</p>
							</div>
						</div>
						<div className="pgc2">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Frequent team events </p>
							</div>
						</div>
						<div className="pgc2 less-bottom">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Paid parental leave</p>
							</div>
						</div>
						<div className="pgc2 less-bottom">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Home office stipend</p>
							</div>
						</div>
						<div className="pgc2 less-bottom">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Flex Fridays</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/*Benefits mobile*/}
			<section className="bgGrey benefits tablet">
				<div className="container tablet">
					<div className="benefits-title">
						<h2 className="text-center">Benefits</h2>
					</div>
					<div className="pgc1 max-width-pgc1 display-block-pgc1 text-left">
						<div className="pgc2">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Healthcare benefits</p>
							</div>
						</div>
						<div className="pgc2">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Mental health benefits</p>
							</div>
						</div>
						<div className="pgc2">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Paid parental leave</p>
							</div>
						</div>
						<div className="pgc2">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>401k</p>
							</div>
						</div>
						<div className="pgc2">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Professional development stipend</p>
							</div>
						</div>
						<div className="pgc2">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Home office stipend</p>
							</div>
						</div>
						<div className="pgc2 less-bottom">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Paid time off</p>
							</div>
						</div>
						<div className="pgc2 less-bottom">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Frequent team events</p>
							</div>
						</div>
						<div className="pgc2 less-bottom">
							<div className="pgc3">
								<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark" />
								<p>Flex Fridays</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/*Conclusion*/}
			<section className="conclusion container">
				<div className="conclusion-content">
					<h2 className="text-center">Get on this rocketship, now!</h2>
					<a className="button primary join-team" href="/company/job-openings/" target="_blank">
						JOIN OUR TEAM
					</a>
				</div>
			</section>
		</Layout>
	);
};


export default Home;